import React from 'react';

import style from './google-map-markers.module.scss';

interface Props {
	color?: string;
	icon: string | JSX.Element;
	title: string;
}
const IconMarker = ({ color, icon, title }: Props) => {
	return (
		<div
			className={style.iconMarker}
			data-test-id={`icon-marker-${title}`}
			style={{ ['--icon-color' as any]: color || 'unset' }}
		>
			{icon}
		</div>
	);
};

export default IconMarker;
